<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-03-01 10:51:46
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Holiday\HolidayType\HolidayType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-01 16:24:24
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_holidayType_list_title')"
    :addBtn="hasBtn('add-admin-public-holiday-type')"
    backgroundClass="transparent"
    pad="0"
    @new="toNew"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275"
        :filter-page-data="filterPageData"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.holiday_type_name="{ item }">{{
          $getCommonLangValue(item.holiday_type_name)
        }}</template>
        <template v-slot:item.holiday_type_code="{ item }">{{
          item.holiday_type_code
        }}</template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-public-holiday-type')"
            :editBtn="hasBtn('edit-admin-public-holiday-type')"
            :viewBtn="hasBtn('view-admin-public-holiday-type')"
            :title="$t('label_essweb_holidayType_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toView"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "HolidayType",

  computed: {},
  data() {
    return {
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_holidayType_list_HolidayTypeNameLabel",
          value: "holiday_type_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_holidayType_list_HolidayTypeCodeLabel",
          value: "holiday_type_code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterObjects: [],
      filterPageData: null,
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    getList: function (data, page, perpage, callback) {
      const that = this;
      let filter = {
        cpage: page,
        pagesize: perpage,
      };
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_type",
        url: "/holiday-type/get-list/",
        data: data ? data : filter,
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/holiday-type/add", {});
    },
    toEdit(uuid) {
      this.$toPage("/admin/holiday-type/edit/" + uuid);
    },
    toView(uuid) {
      this.$toPage("/admin/holiday-type/detail/" + uuid);
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_type",
        url: "/holiday-type/delete-table/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_holidayType_list_deleteHolidayTypeSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
  },
};
</script>